/* eslint-disable react/prop-types */
import React from 'react'
import { dangericon, error02 } from '../../imagepath';

const ServerError = ({ onRetry }) => {
  return (
    <>
     <div className="main-wrapper error-wrapper">
  <div className="error-box">
    <img className="img-fluid" src={error02} alt="Logo" />
    <h3>
      <img
        className="img-fluid mb-0"
        src={dangericon}
        alt="Logo"
      />{" "}
      Algo salió mal
    </h3>
    <p>Ocurrió un error inesperado en la aplicación. Puedes intentar nuevamente o volver al inicio.</p>
    <div className="d-flex gap-2 justify-content-center flex-wrap">
      {onRetry && (
        <button type="button" className="btn btn-primary go-home" onClick={onRetry}>
          Reintentar
        </button>
      )}
      <a href="/" className="btn btn-outline-secondary go-home">
        Volver al inicio
      </a>
    </div>
  </div>
</div>


    </>
  )
}

export default ServerError;
